/** Maps task.related to listing-shaped entry/parking fields for Case, Listing, Location, and Reservation tasks (not LOIs). */
export function entryParkingListingFromTask(
  task: ApiTask,
): ApiListing | null {
  if (!task.related) {
    return null;
  }

  switch (task.related_type) {
    case "Listing__c":
    case "Case":
    case "Reservation__c":
    case "Reservation_Order_Item__c":
      return task.related as ApiListing;
    case "Location": {
      const loc = task.related as ApiLocation;
      return {
        address: loc.address,
        latitude: loc.latitude,
        longitude: loc.longitude,
        entry_instructions: loc.driving_directions,
      } as ApiListing;
    }
    default:
      return null;
  }
}
